import { CSSProperties, type ReactNode, useContext } from 'react';
import styles from './Heading.module.scss';
import { HeadingContext } from './HeadingContext';

interface Props {
  children: string;
  level?: 1 | 2 | 3 | 4;
  spacing?: 'both' | 'top' | 'bottom' | 'none';
  sub?: ReactNode;
  style?: CSSProperties;
}

export function Heading(props: Props) {
  const { children, spacing = 'both' } = props;
  const context = useContext(HeadingContext);
  const level = (props.level ?? 1) + (context?.level ?? 0);

  const className = [
    styles[`heading`],
    styles[`level-${level}`],
    styles[`spacing-${spacing}`],
  ]
    .filter(Boolean)
    .join(' ');

  let headingElement;
  switch (level) {
    case 1:
      headingElement = <h1 style={props.style}>{children}</h1>;
      break;
    case 2:
      headingElement = <h2 style={props.style}>{children}</h2>;
      break;
    case 3:
      headingElement = <h3 style={props.style}>{children}</h3>;
      break;
    case 4:
      headingElement = <h4 style={props.style}>{children}</h4>;
      break;
    default:
      headingElement = <h1 style={props.style}>{children}</h1>;
  }

  return (
    <div className={className}>
      {headingElement}
      <div>{props.sub}</div>
    </div>
  );
}
